
<section id="process-header">
  <h2 class="process-list-title">Vorgangsliste</h2>

  <div class="process-filter">

    <div class="search">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
      <input #search type="search"class="search-input" [(ngModel)]="searchText" placeholder="Nummer, Art, Position..." (ngModelChange)="onSearchValueChange()"/>
    </div>

    <div class="filter-bttn" (click)="openTypeFilter($event)">
      {{selectedProcessType.name}}
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" class="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
    </div>

  </div>

</section>

@if(isLoading){
  <section id="loading">
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
  </section>
}
@else if(processes.length == 0){
<p class="no-content">Keine Vorgänge gefunden</p>
}
@else {
<section id="process-content">
  @for (process of processes; track process) {
    <div class="process-item" (click)="openProcessDetails($event, process)" [class.process-item-canceled]="process.canceled">
      <div class="process-item-header">
        <h3 class="process-item-type">{{process.type.name}}</h3>
        <h4 class="process-item-date">{{process.date | date : 'dd.MM.yyyy'}}</h4>
      </div>
      <div class="process-item-body">
        <div class="process-item-body-item">
          <h4 class="process-item-body-item-title">VorgangsNr.:</h4>
          <p class="process-item-body-item-value">{{process?.number || "-"}}</p>
        </div>
        <div class="process-item-body-item">
          <h4 class="process-item-body-item-title">Betrag:</h4>
          <p class="process-item-body-item-value">{{process.amount | currency }}</p>
        </div>
        @if (process.type?.id == 4 && !process.canceled) {
          <div class="process-item-body-item">
            <h4 class="process-item-body-item-title">Bezahlt:</h4>
            <p class="process-item-body-item-value">
              @switch(process.payState){
                @case('PAID') { <span class="process-text-colored process-text-green">Bezahlt</span> }
                @case('OPEN'){ <span class="process-text-colored process-text-red">Unbezahlt</span> }
                @case('PARTLY_PAID'){ <span class="process-text-colored process-text-yellow"> Teilweise bezahlt </span> }
              }
            </p>
          </div>
        }
      </div>
    </div>
  }
</section>

@if (showMore) {
  <section id="process-items-load-more">
    <ion-chip class="button-chip selectable" mode="ios" (click)="loadMoreProcesses()">
      @if(isMoreLoading){ <ion-icon class="spinner" name="fa-spinner"></ion-icon> }
      @else { <ion-icon name="fa-arrow-down-small"></ion-icon> }
      <ion-label> Mehr laden... </ion-label>
    </ion-chip>
  </section>
}
}

